import React from 'react';
// import axios from 'axios';
// import { BASE_URL, API_KEY } from './constants';

import Header from './components/Header';
import NasaInfo from './components/NasaInfo';
// import Footer from './components/Footer';

function App() {
  return (
      <div>
        <Header />
        <NasaInfo />
      </div>
  );
}

export default App;
